/**
 * 用户状态检查工具函数
 */

/**
 * 检查用户是否需要填写单位信息
 * @param {Object} userInfo 用户信息对象
 * @returns {boolean} 是否需要填写单位信息
 */
export function needsUnitInfo(userInfo) {
  return userInfo.roleId === 2 && userInfo.mark !== 1
}

/**
 * 检查用户是否需要选课
 * @param {Object} userInfo 用户信息对象
 * @returns {boolean} 是否需要选课
 */
export function needsCourseSelection(userInfo) {
  console.log('检查是否需要选课 - 用户信息:', userInfo)
  console.log('已关闭“需要先选课”访问限制')
  return false
}

/**
 * 获取用户应该跳转的页面
 * @param {Object} userInfo 用户信息对象
 * @returns {string} 跳转路径
 */
export function getUserRedirectPath(userInfo) {
  // 机构用户重定向到机构首页
  if (userInfo.roleId === 6) {
    return '/org/dashboard'
  }
  // 管理员默认重定向到用户管理
  if (userInfo.roleId === 3) {
    return '/user-management'
  }
  if (needsUnitInfo(userInfo)) {
    return '/unit-info'
  }
  // 学生用户登录后直接跳转到 Landing 页面
  if (userInfo.roleId === 1) {
    return '/landing'
  }
  // 教师默认进入主页
  if (userInfo.roleId === 2) {
    return '/dashboard'
  }
  // 家长默认进入家长主页，用于绑定和管理学生
  if (userInfo.roleId === 5) {
    return '/dashboard'
  }
  return '/'
}

/**
 * 检查用户是否可以访问指定页面
 * @param {Object} userInfo 用户信息对象
 * @param {string} path 要访问的路径
 * @returns {boolean} 是否可以访问
 */
export function canAccessPage(userInfo, path) {
  console.log('权限检查 - 用户信息:', userInfo, '访问路径:', path)

  // 白名单路径，所有用户都可以访问
  const whiteList = ['/login', '/register', '/unit-info', '/course-required', '/subject-select', '/contact', '/amc-course', '/amc-level-select', '/amc-plan-details', '/landing', '/user-profile', '/knowledge-practice', '/amc-past-papers', '/amc-classroom', '/quick-practice', '/daily-question', '/today-wrong', '/consecutive-challenge', '/wrong-questions', '/practice-record', '/knowledge-base', '/learning-analytics', '/gesp-mock-test', '/gesp-practice', '/app-download']
  if (whiteList.includes(path)) {
    console.log('白名单路径，允许访问')
    return true
  }

  // 项目简介页面，所有用户都可以访问
  if (path.startsWith('/intro/')) {
    console.log('项目简介页面，允许访问')
    return true
  }

  // 机构用户(roleId=6)可以访问机构管理页面
  if (userInfo.roleId === 6) {
    if (path.startsWith('/org')) {
      console.log('机构用户访问机构管理页面，允许访问')
      return true
    }
    // 机构用户允许访问教师课程详情页（复用教师端课程资料/学情分析/数据收集等功能）
    if (path.startsWith('/teacher-course/') || path.startsWith('/course/teacher/') || path.startsWith('/amc/teacher-course/')) {
      console.log('机构用户访问教师课程详情页面，允许访问')
      return true
    }
    // 机构用户默认重定向到机构首页
    console.log('机构用户访问非机构页面，将重定向')
    return path === '/org/dashboard'
  }

  // 如果用户需要填写单位信息，只能访问单位信息页面
  if (needsUnitInfo(userInfo)) {
    console.log('用户需要填写单位信息，检查路径:', path === '/unit-info')
    return path === '/unit-info'
  }

  // 对于教师用户，如果访问课程详情页面，总是允许（后端会验证权限）
  if (userInfo.roleId === 2 && path.startsWith('/course/detail/')) {
    console.log('教师用户访问课程详情页面，允许访问（后端会验证权限）')
    return true
  }

  // 对于学生用户，如果访问课程详情页面，总是允许（后端会验证是否已选课）
  if (userInfo.roleId === 1 && path.startsWith('/course/detail/')) {
    console.log('学生用户访问课程详情页面，允许访问（后端会验证选课状态）')
    return true
  }

  // 用户状态正常，可以访问所有页面
  console.log('用户状态正常，允许访问所有页面')
  return true
}

/**
 * 更新用户状态
 * @param {string} key 状态键名
 * @param {any} value 状态值
 */
export function updateUserStatus(key, value) {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo) {
      userInfo[key] = value
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  } catch (error) {
    console.error('更新用户状态失败:', error)
  }
}

/**
 * 获取用户状态
 * @param {string} key 状态键名
 * @returns {any} 状态值
 */
export function getUserStatus(key) {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    return userInfo ? userInfo[key] : null
  } catch (error) {
    console.error('获取用户状态失败:', error)
    return null
  }
}
